import PropTypes from 'prop-types';
import React from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import { TickerInfoEditor, TickerTextEditor } from '..';
import Box from '../layout/Box';
import Button from '../widgets/Button';
import Icon from '../widgets/Icon';
import './styles.scss';

class TickerView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {editing: false, ticker: {...props.ticker}};
  }

  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    connectDragPreview: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    isDragging: PropTypes.bool.isRequired,
    moveItem: PropTypes.func.isRequired,
    dropItem: PropTypes.func.isRequired,
    onTickerDelete: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onClone: PropTypes.func.isRequired,
    ticker: PropTypes.shape({
      id: PropTypes.number.isRequired,
      text: PropTypes.string.isRequired,
      speed: PropTypes.number.isRequired,
      font_family: PropTypes.string,
      font_size: PropTypes.string,
      colour: PropTypes.string.isRequired,
      outline: PropTypes.string.isRequired,
      background: PropTypes.string.isRequired,
    }).isRequired,
  };

  handleChange = (newVal) => this.setState({ticker: {...this.state.ticker, ...newVal}});

  handleClone = () =>
    this.props.onClone({...this.state.ticker, id: undefined, position: undefined})

  handleDelete = () => this.props.onTickerDelete(this.props.ticker.id);

  handleTextChange = (newText) => this.setState({ticker: {...this.state.ticker, text: newText}});

  onCancel = () => {
    this.onStopEdit();
    this.resetState();
  }

  onSave = () => {
    this.onStopEdit();
    this.props.onSave(this.state.ticker);
  }

  onStartEdit = () => this.setState({editing: true});

  onStopEdit = () => this.setState({editing: false});

  resetState = () => this.setState({ticker: {...this.props.ticker}});

  saveCancelButtons = () => (
    <Box direction="row" justifyContent="flex-end" className="button-group">
      <Button onClick={this.onSave}>Save</Button>
      <Button onClick={this.onCancel} secondary>Cancel</Button>
    </Box>
  )

  getTickerStyle() {
    const {font_family, font_size, colour, outline, background} = this.state.ticker;
    const outlineShadow = outline
      ? `-1px -1px 0 ${outline}, 1px -1px 0 ${outline},-1px 1px 0 ${outline}, 1px 1px 0 ${outline}`
      : null;

    return {
      fontFamily: font_family,
      fontSize: `${font_size}pt`,
      color: colour,
      textShadow: outlineShadow,
      background: background,
    };
  }

  render() {
    const {isDragging, connectDragSource, connectDragPreview, connectDropTarget} = this.props;
    const opacity = isDragging ? 0 : 1;

    return connectDropTarget(connectDragPreview(
      <div style={{opacity}} className="ticker-view-item" ref={node => this.node = node}>
        <Box direction="row" justifyContent="center" alignItems="center">
          {!this.state.editing &&
          connectDragSource(
            <div className="drag-icon">
              <Icon title="Click and drag to reorder" name="bars" size="2rem"/>
            </div>)}
          <TickerTextEditor text={this.state.ticker.text}
                            onDoubleClick={this.onStartEdit}
                            onChange={this.handleTextChange}
                            tickerStyle={this.getTickerStyle()}
                            isEditing={this.state.editing}/>
          {!this.state.editing &&
          <Icon title="Create a copy" name="clone" size="2rem" onClick={this.handleClone}/>}
          {!this.state.editing &&
          <Icon title="Delete" name="trash-o" size="2rem" onClick={this.handleDelete}/>}
        </Box>
        {this.state.editing &&
        <TickerInfoEditor ticker={this.state.ticker} onChange={this.handleChange}/>}
        {this.state.editing && this.saveCancelButtons()}
      </div>,
    ));
  }
}

const dragSource = {
  beginDrag(props) {
    return {
      id: props.ticker.id,
      index: props.index,
    };
  },
};

const dragTarget = {
  drop(props) {
    props.dropItem();
  },
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) return;

    // Determine rectangle on screen
    const hoverBoundingRect = component.getDecoratedComponentInstance()
                                       .node.getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;

    props.moveItem(dragIndex, hoverIndex);

    monitor.getItem().index = hoverIndex;
  },
};

const makeTarget = DropTarget('TICKER_ITEM', dragTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}));

const makeSource = DragSource('TICKER_ITEM', dragSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
}));

export default makeTarget(makeSource(TickerView));



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/TickerView/index.js